import React, { useState, useRef, useEffect } from 'react';
import AdvancedDataTableComponent from '../../common/AdvancedDataTableComponent';
import FloatingLabelSelect from '../../ui/FloatingLabelSelect';
import { fetchUserDataByClient } from '../../../services/client/customerApiService';
import { fetchUserDataUnderLoginUserByClient, getAttendanceListByFilters } from '../../../services/client/reportApiService';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Ensure CSS for datepicker is imported
import AlternateDatePicker2 from '../../ui/AlternateDatePicker2';
import { FaMapMarkerAlt } from "react-icons/fa"

const AttendanceReportForm = () => {
    const [loading, setLoading] = useState(false);
    const [apiResponse, setApiResponse] = useState(null);
    const [formValues, setFormValues] = useState({
        clientId: '',
        loginUserId: '',
        userId: -1,
        fromDate: null,
        toDate: null
    });
    const [users, setUsers] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);  // Data for the table
    const [animateTable, setAnimateTable] = useState(false); // New state for animation
    const [errors, setErrors] = useState({});

    const inputClasses = (field) => (errors[field] ? 'border-red-500' : 'border-gray-300');

    useEffect(() => {
        const getUsers = async () => {
            try {
                const userData = await fetchUserDataUnderLoginUserByClient(localStorage.getItem('clientID'),localStorage.getItem('userID'));
                setUsers([{ value: -1, label: 'All' }, ...userData.map(user => ({ value: user.userId, label: user.userName }))]);
            } catch (error) {
                console.error("Error fetching clients:", error);
            }
        };
        getUsers();
    }, []);

    const validate = () => {
        const newErrors = {};

        if (!formValues.userId) newErrors.userId = 'User is required';
        if (!formValues.fromDate) newErrors.fromDate = 'FromDate is required';
        if (!formValues.toDate) newErrors.toDate = 'ToDate is required';
        return newErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
    };

    // Define Button Styles
const buttonStyle = {
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    padding: "6px 12px",
    display: "flex",
    alignItems: "center",
    borderRadius: "5px",
    cursor: "pointer"
};

const iconStyle = {
    marginRight: "5px"
};
    // Function to process API response and convert map URLs to JSX
const processAttendanceData = (apiData) => {
    return apiData.map(item => ({
        ...item,
        checkInMapUrl: item.checkInLatitude && item.checkInLongitude 
            ? (
                <a 
                    href={`https://www.google.com/maps/search/?api=1&query=${item.checkInLatitude},${item.checkInLongitude}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                    >
                        <button style={buttonStyle}>
                            <FaMapMarkerAlt style={iconStyle} /> Map
                        </button>
                </a>
            ) 
            : "N/A",
        checkOutMapUrl: item.checkOutLatitude && item.checkOutLongitude 
            ? (
                <a 
                    href={`https://www.google.com/maps/search/?api=1&query=${item.checkOutLatitude},${item.checkOutLongitude}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                >
                    <button style={buttonStyle}>
                        <FaMapMarkerAlt style={iconStyle} /> Map
                    </button>
                </a>
            ) 
            : "N/A"
    }));
};

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length === 0) {
            setLoading(true);
            try {
                // Manually add the clientId here instead of relying on the setFormValues update
                const updatedFormValues = { ...formValues, clientId: localStorage.getItem('clientID'), loginUserId: localStorage.getItem('userID'),  };

                //console.log(updatedFormValues); // You should see the clientId now included here
                const data = await getAttendanceListByFilters(updatedFormValues);
                if (data.success && data.success.length > 0) {
                    const formattedData = processAttendanceData(data.success); // Convert API response
            setAttendanceData(formattedData);
                   // setAttendanceData(data.success);
                    // Trigger animation when data is updated
          //setAnimateTable(true);
          //setTimeout(() => setAnimateTable(false), 500); // Reset animation state
                    setApiResponse({ success: 'Files fetched successfully!' });
                } else {
                    setAttendanceData([]);
                    setApiResponse({ error: 'No Data Found' });
                }
            } catch (error) {
                console.error("Submission failed:", error);
                setApiResponse({ error: 'Failed to submit form. Please try again.' });
                setAttendanceData([]);
            } finally {
                setLoading(false);
                setErrors(validationErrors);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    const resetFormValues = () => {
        setFormValues({
            clientId: '',
            userId: -1,
            fromDate: null,
            toDate: null
        });
        setErrors({});
    };

    const tableHeaders = ["User Name", "Date", "Check In Time","Check In Location", "Check In Map",
    "Check Out Time","Check Out Location","Check Out Map"];
    
    const headerMapping = {
        "User Name": "userName",
        "Date": "attendanceDate",
        "Check In Time": "checkInTime",
        "Check In Location":"checkInAddress",
        "Check In Map":"checkInMapUrl",
        "Check Out Time": "checkOutTime",
        "Check Out Location": "checkOutAddress",
        "Check Out Map":"checkOutMapUrl",
    };

    return (
        <div className="container mx-auto p-6 bg-white rounded-lg border">
            <form onSubmit={handleSubmit} className="space-y-6 w-full">
                <h1>Attendance</h1>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div>
                        {/* Users Dropdown */}
                        {loading ? (
                            <p>Loading Users...</p>
                        ) : (
                            <FloatingLabelSelect
                                label="Select User"
                                id="userId"
                                name="userId"
                                value={users.find(user => user.value === formValues.userId) || null}
                                onChange={(option) => setFormValues({ ...formValues, userId: option.value })}
                                className="input-class"
                                options={users} // Including 'All Clients' option
                                isSearchable={true}
                            />
                        )}
                        {errors.userId && <div className="text-red-500 text-sm">{errors.userId}</div>}
                    </div>
                
                    <div>
                        {/* From Date Picker */}
                        <AlternateDatePicker2
                            label="From Date"
                            id="fromDate"
                            name="fromDate"
                            value={formValues.fromDate ? new Date(formValues.fromDate) : null}
                            onChange={(event) => {
                                const date = event.target.value ? event.target.value : null;
                                setFormValues({ ...formValues, fromDate: date });
                            }}
                            className={inputClasses('fromDate')}
                        />

                        {errors.fromDate && <div className="text-red-500 text-sm">{errors.fromDate}</div>}
                    </div>



                    <div>
                        {/* To Date Picker */}
                        <AlternateDatePicker2
                            label="To Date"
                            id="toDate"
                            name="toDate"
                            value={formValues.toDate ? new Date(formValues.toDate) : null}
                            onChange={(event) => {
                                const date = event.target.value ? event.target.value : null;
                                setFormValues({ ...formValues, toDate: date });
                            }}
                            className={inputClasses('toDate')}
                        />
                        {errors.toDate && <div className="text-red-500 text-sm">{errors.toDate}</div>}
                    </div>

                    <div>
                        <button
                            type="submit"
                            className={`px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 ${loading ? 'opacity-50' : ''}`}
                            disabled={loading}
                        >
                            {loading ? 'Searching...' : 'Search'}
                        </button>
                    </div>
                </div>
            </form>
            <br />
            <hr />
            <br />
            {(attendanceData!=null && attendanceData.length>0) ? ( 
            <div
        className={`${
          animateTable ? "paper-fly" : ""
        }`}
      >
            <AdvancedDataTableComponent
                headers={tableHeaders}
                data={attendanceData}
                headerMapping={headerMapping}
            />
            </div>
            ):<div>No Data found</div>}
        </div>
    );
};


export default AttendanceReportForm;

